const SocialLink = ({ icon, onClick }) => {
  return (
    <div onClick={onClick} className="text-4xl cursor-pointer hover:opacity-75">
      {icon}
    </div>
  )
}

export default SocialLink
